import { useSelector } from 'src/hooks/useSelector';
import { octoOrderAtom, selectOctoOrder, selectIsLoading } from 'src/state/octo-cart/octoOrderAtom';
import { useAtom } from 'ximple';

export default function useOctoOrderInCart() {
    const [octoOrderState] = useAtom(octoOrderAtom);
    const octoOrder = useSelector(octoOrderState, selectOctoOrder);
    const isLoading = useSelector(octoOrderState, selectIsLoading);

    return { octoOrder, isLoading };
}
